import { render, staticRenderFns } from "./OrderExpressEdit.vue?vue&type=template&id=5f5dd9a4&"
import script from "./OrderExpressEdit.vue?vue&type=script&lang=js&"
export * from "./OrderExpressEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports